module.exports = __webpack_public_path__ + "static/img/tulanduo_icon.4e73e5f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/tulanduo_icon.png
// module id = +QJ4
// module chunks = 1